"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAXIMUM_PHONE_LENGTH = exports.DEFAULT_WARNING = exports.DEFAULT_COUNTRY_CODE = exports.DEFAULT_COUNTRY_STATE = void 0;
exports.DEFAULT_COUNTRY_STATE = 'United States';
exports.DEFAULT_COUNTRY_CODE = 'US';
exports.DEFAULT_WARNING = 'Please enter valid phone number';
exports.MAXIMUM_PHONE_LENGTH = 15;
